import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startOfDayInMilliseconds } from '@utils/date';
import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface InitialState extends TDefaultStoreDTO {
	severity: string | null;
	name: string | null;
	fromDate: number | null;
	toDate: number | null;
}

const initialState: InitialState = {
	...defaultMeta,
	searchValue: '',
	sortDirection: false,
	sortFieldName: 'alarmTime',
	severity: null,
	name: null,
	fromDate: null,
	toDate: null,
};

const activeAlarmsFlexidas = createSlice({
	name: 'activeAlarmsFlexidas',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setSeverity: (state, action: PayloadAction<{ severity: string | null }>) => {
			state.severity = action.payload.severity;
			state.page = initialState.page;
		},
		setName: (state, action: PayloadAction<{ name: string | null }>) => {
			state.name = action.payload.name;
			state.page = initialState.page;
		},
		setFromDate: (
			state,
			action: PayloadAction<{ fromDate: number | null }>,
		) => {
			if (action.payload.fromDate) {
				state.fromDate = startOfDayInMilliseconds(action.payload.fromDate);
			} else {
				state.fromDate = null;
			}

			state.page = initialState.page;
		},
		setToDate: (
			state,
			action: PayloadAction<{ toDate: number | null }>,
		) => {
			if (action.payload.toDate) {
				state.toDate = startOfDayInMilliseconds(action.payload.toDate);
			} else {
				state.toDate = null;
			}

			state.page = initialState.page;
		},
		resetActiveAlarmsTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSearchValue,
	setSort,
	setSeverity,
	setName,
	setFromDate,
	setToDate,
} = activeAlarmsFlexidas.actions;

export default activeAlarmsFlexidas.reducer;
